import { render, staticRenderFns } from "./ComPartner.vue?vue&type=template&id=07f3acae&scoped=true&"
import script from "./ComPartner.vue?vue&type=script&lang=js&"
export * from "./ComPartner.vue?vue&type=script&lang=js&"
import style0 from "./ComPartner.vue?vue&type=style&index=0&id=07f3acae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3acae",
  null
  
)

export default component.exports